import React from "react"
import * as S from "./submit-transaction.styles"
import { Grid } from "@mui/material"
import StatisticsItem from "../../components/statistics-item/statistics-item.component"
import SubmitIcon from "../../assets/submit-icon.svg"

const SubmitTransaction = ({
  title,
  description,
  gridItems,
  buttonLink,
  hasIconButton,
}) => {
  // if (!title) return null

  return (
    <S.Section>
      <S.Wrapper maxWidth="xl">
        <S.TextWrapper>
          {title && <S.Title>{title}</S.Title>}
          {description && <S.Description>{description}</S.Description>}
        </S.TextWrapper>
        <S.DamnCustomButton href={buttonLink?.url} target={buttonLink?.target}>
          {hasIconButton && <SubmitIcon />} {buttonLink?.title}
        </S.DamnCustomButton>
        <S.StatisticsWrapper maxWidth="md">
          <Grid container spacing={{ xs: 4, md: 2 }} justifyContent="center">
            {gridItems.map((item, index) => (
              <StatisticsItem
                key={index}
                text={item.text}
                number={item.number}
                beforeIcon={item.beforeIcon}
                afterIcon={item.afterIcon}
              />
            ))}
          </Grid>
        </S.StatisticsWrapper>
      </S.Wrapper>
    </S.Section>
  )
}
export default SubmitTransaction
